<template>
    <div>
      <div class="card mb-3">
          <div class="row no-gutters" style="min-height: 56vh; overflow: auto;">
            <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
              <div class="card-body">
                  <h6 class="heading-small text-muted mb-4">Filter by status</h6>
                  <div>
                      <base-radio name="0" class="mb-3" v-model="filterStatus" value="O">
                          All
                      </base-radio>
                      <base-radio name="A" class="mb-3" v-model="filterStatus" value="A">
                          Active
                      </base-radio>
                      <base-radio name="I" class="mb-3" v-model="filterStatus" value="I">
                          Inactive
                      </base-radio>
                      <base-radio name="D" class="mb-3" v-model="filterStatus" value="D">
                          Deleted
                      </base-radio>
                  </div>
              </div>
            </div>
            <div class="col-md-9" >
              <div class="card-body">
                  <div class="ml-2"><h2 class="card-title">GC Items</h2></div>
                  <a-table :scroll="{ x: 1000 }" size="small" rowKey="id" :columns="columns" :data-source="data" style="min-height: 50vh; overflow: auto;">
                      <span slot="retail_price" slot-scope="text, record">
                          <a-tag color="blue">{{record.retail_price}}</a-tag>
                      </span>
                      <span slot="price5" slot-scope="text, record">
                          <a-tag color="green">{{record.price5}}</a-tag>
                      </span>
                      <span slot="status" slot-scope="text, record">
                          <a-tag v-if="record.status == 'A'" color="green">Active</a-tag>
                          <a-tag v-if="record.status == 'I'" color="orange">Inactive</a-tag>
                          <a-tag v-if="record.status == 'D'" color="red">Deleted</a-tag>
                      </span>
                      <span slot="action" slot-scope="text, record">
                        <center>
                          <a-dropdown>
                            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                              <i class="fa fa-ellipsis-v"></i>
                            </a>
                            <a-menu slot="overlay">
                              <template>
                                <a-menu-item>
                                  <button class="btn btn-warning btn-sm" @click.prevent="$emit('changeGC', record.id + '|' + record.name + '|' + record.price5)">
                                    &nbsp;&nbsp;Modify GC Codes&nbsp;&nbsp;
                                  </button>
                                </a-menu-item>
                              </template>
                            </a-menu>
                          </a-dropdown>
                        </center>
                      </span>
                      <span slot="deployed_at" slot-scope="text, record">
                          {{deployAt(record.deployed_at)}}
                      </span>
                  </a-table>
              </div>
            </div>
          </div>
      </div>
    </div>

</template>

<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import secureStorage from '../../controllers/secureStorage.js'
import { mapState, mapActions } from 'vuex'
import moment from 'moment';

const columns = [
{
    title: '',
    dataIndex: '',
    scopedSlots: { customRender: 'action' },
    fixed: "left",
    align: "center",
  },
  {
    title: 'Description',
    dataIndex: 'name',
    sorter: true,
    fixed: 'left'
  },
  {
    title: 'Barcode',
    dataIndex: 'barcode',
    sorter: true,
  },
  {
    title: 'Retail Price',
    dataIndex: 'retail_price',
    ellipsis: true,
    scopedSlots: { customRender: 'retail_price' },
    sorter: true
  },
  {
    title: 'GC Value',
    dataIndex: 'price5',
    ellipsis: true,
    scopedSlots: { customRender: 'price5' },
    sorter: true
  },
  {
    title: 'Status',
    dataIndex: 'status',
    ellipsis: true,
    scopedSlots: { customRender: 'status' },
    sorter: true
  }
];

export default {
  mounted: async function(){  
    
  },
  computed: {
       ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
  },
  watch: {
    filterStatus: function() {
      this.retrieveGC(null, this.filterStatus)
      this.filterText = ''
    }
  },
  data () {
    return {
        drawerVisibleStats: false,
        filterTag: 0,
        selectedProfile: "pos_releases",
        columns,
        data: [],
        userCode: secureStorage.getItem("userCode"),
        filterStatus: '0',
        filterText: '',
    }
  },
  mounted: async function(){
    this.retrieveGC(null, '0')
  },
  methods: {
    filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    async retrieveGC(search, status){
      if (search == null && (status == null || status == '0')) {
        var pos_releases = await HTTPRequest.getRequest(this.endPoint + 'products?type=gift_certificate', null)
        if (pos_releases) this.data = pos_releases['data']
      } else {
        let filters = ``;
        filters += `&status=${this.filterStatus}`;
        var pos_releases = await HTTPRequest.getRequest(this.endPoint + 'products?type=gift_certificate'+filters, null)
        if (pos_releases) this.data = pos_releases['data']
      }
    },
    setCurrentProfile(profile){
      this.selectedProfile = profile
    },
  },
}
</script>

<style>
</style>


